import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protection-plan',
  templateUrl: './protection_plan.component.html',
  styleUrls: ['./protection_plan.component.css']
})
export class ProtectionPlanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
